// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'truck-clock';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M3.403 5.813H5.28V3.934M10.594 9h1.062a1.063 1.063 0 0 1 1.063 1.063v3.745m-6.906 1.567H5.28a1.062 1.062 0 0 1-1.062-1.063v-2.124m8.501-2.125h2.125a2.125 2.125 0 0 1 2.125 2.124v2.126a1.063 1.063 0 0 1-1.063 1.062h-1.62' />
    <path d='M1.031 5.813a4.25 4.25 0 1 0 8.5 0 4.25 4.25 0 0 0-8.5 0zm10.625 9.297a1.329 1.329 0 1 0 2.658-.001 1.329 1.329 0 0 0-2.658 0zm-5.843 0a1.328 1.328 0 1 0 2.656 0 1.328 1.328 0 0 0-2.656 0zm5.87.265H8.47m8.499-3.187h-2.125' />
  </g>
);

export const viewBox = '0 0 18 18';
